import { clone, accountTime, applyAction } from './sessionModel';

export function makeOperation(checkpoint, lesson, action, elapsedMs, clicks = [], droppedClicks = 0, now = Date.now(), mediaEvents = []) {
  const next = clone(checkpoint);
  const stage = lesson.stages[checkpoint.progress.stage_index];
  const context = { study_id: lesson.study_id, lesson_id: lesson.lesson_id, lesson_version: lesson.lesson_version,
    session_id: checkpoint.session_id, stage_id: stage.id, data_mode: checkpoint.data_mode };
  accountTime(next, lesson, elapsedMs);
  const before = clone(next.stage_states[stage.id]);
  applyAction(next, lesson, action, now);
  next.total_clicks += clicks.length + droppedClicks;
  const events = clicks.map(click => ({ ...context, ...click, type: 'click' }));
  events.push(...mediaEvents.map(media => ({ ...context, ...media })));
  const event = { ...context, type: action.type, at: new Date(now).toISOString(), session_ms: next.total_active_ms, action: clone(action) };
  if (!['heartbeat', 'visibility', 'session_resume'].includes(action.type) && !action.type.startsWith('audio_')) {
    event.state_before = before;
    event.state_after = clone(next.stage_states[stage.id]);
  }
  events.push(event);
  if (droppedClicks) events.push({ ...context, type: 'click_buffer_overflow', count: droppedClicks, at: event.at });
  if (action.type === 'page' || (action.type === 'stage_complete' && stage.type === 'reader')) {
    const page = stage.pages[before.page_index];
    events.push({ ...context, type: 'page_leave', material_id: page.id, view_total_ms: before.page_view_ms[page.id] || 0, at: event.at });
  }
  if (action.type === 'page') events.push({ ...context, type: 'page_enter', material_id: stage.pages[action.index].id, at: event.at });
  if (action.type === 'session_resume' && stage.type === 'reader') events.push({ ...context, type: 'page_enter', material_id: stage.pages[before.page_index].id, resumed: true, at: event.at });
  if (action.type === 'session_start' || (action.type === 'stage_complete' && next.status !== 'completed')) {
    const entered = lesson.stages[next.progress.stage_index];
    events.push({ ...context, stage_id: entered.id, type: 'stage_start', initial_state: clone(next.stage_states[entered.id]), at: event.at });
    if (entered.type === 'reader') events.push({ ...context, stage_id: entered.id, type: 'page_enter', material_id: entered.pages[0].id, at: event.at });
  }
  if (action.type === 'stage_complete') events.push({ ...context, type: next.status === 'completed' ? 'session_complete' : 'stage_end', completion_kind: next.stage_records[stage.id].completion_kind, at: event.at });
  return { operation_id: crypto.randomUUID(), base_revision: checkpoint.revision, checkpoint: next, events };
}
